import request from '@/lib/request'


/***
 * 获取商品分类列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getGoodsCategory(params = {}) {
  return request.get('/api/v1/rental/category/list', {
    "pageNum": params.pageNum || 1,
    "pageSize": params.pageSize || 20,
    "location": params.location,
    "showPrice": params.showPrice === true
  }, {
    _reqLogin: false,
    _showLoading: false
  });
}

/***
 * 获取公开商品列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getGoodsList(params = {}) {
  return request.get('/api/v1/rental/goods/list', {
    "pageNum": params.pageNum || 1,
    "pageSize": params.pageSize || 20
  }, {
    _reqLogin: false,
    _showLoading: false
  });
}

/***
 * 获取商品详情
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getGoodsDetail(params = {}) {
  return request.get(`/api/v1/rental/goods/${params.goodsId}`, {}, {
    _reqLogin: false
  });
}
